module.exports = __webpack_public_path__ + "static/media/family-3.bde82c2d.png";